<template>
  <div class="cover" ref="cover" :style="setBgStyle()" v-loading="isLoadingImg" v-on="$listeners">
    <img class="bg" :src="`//bar.xkw.com${bgConfig.src}`" alt="" />
    <div
      v-if="elConfig.remainPart === 2 || elConfig.remainPart === 0"
      class="right-element"
      :style="setElementStyle('Right')"
    >
      <img
        ref="RImg"
        :src="`//bar.xkw.com${elementImg}`"
        :style="{
          width: `${elConfig.elementWidth * 2}px`,
        }"
        alt="cover右侧元素"
      />
      <span class="element-mask" @click="handleMaskClick"></span>
    </div>
    <div
      class="texts"
      :style="{
        ...textStyle,
        width: textBoxWidth,
      }"
    >
      <label
        v-for="(textMap, index) of fontComputedStyles"
        :key="index"
        class="cover-text"
        :style="{
          marginTop: textMap.style.marginTop,
        }"
      >
        <input
          v-if="!textMap.isMainTitle"
          class="cover-text-input"
          v-model="fontStyles[index].text"
          :style="{
            ...textMap.style,
            marginTop: 0,
          }"
          :placeholder="`请输入${textMap.textMinLength}-${textMap.textMaxLength}个字`"
          :maxlength="textMap.textMaxLength"
          :minlength="textMap.textMinLength"
          type="text"
        />
        <textarea
          v-else
          class="cover-text-area"
          v-model="fontStyles[index].text"
          cols="16"
          rows="2"
          :style="{
            ...textMap.style,
            marginTop: 0,
          }"
          :placeholder="`请输入${textMap.textMinLength}-${textMap.textMaxLength}个字`"
          :maxlength="textMap.textMaxLength"
          :minlength="textMap.textMinLength"
          type="text"
        ></textarea>
        <!-- <div type="text">{{ textMap.text }}</div> -->
      </label>
    </div>
    <label>
      <input
        class="bottom-label"
        v-if="lastFontStyle && lastFontStyle.isShowText"
        :style="lastFontStyle.style"
        v-model="lastFontStyle.text"
        placeholder="请输入文字"
      />
    </label>
  </div>
</template>

<script>
import { getLabelStyleMenu } from "@/assets/scripts/common.js";
import { hexToRGB } from "../../../assets/scripts/utils";

export default {
  name: "AiCover",
  props: {
    size: {
      required: true,
      type: Object,
    },
    bgConfig: {
      required: true,
      type: Object,
    },
    elementImg: {
      required: true,
      type: String,
    },
    textConfig: {
      required: true,
      type: Object,
    },
    fontStyles: {
      required: true,
      type: Array,
    },
    elConfig: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      // 正在加载图片
      isLoadingImg: false,
      // 文字计算后的样式
      fontComputedStyles: [],
      // 如果是竖版，返回最后一个文字样式
      lastFontStyle: null,
      // 文字样式
      textStyle: {},
      textBoxWidth: "300px",
    };
  },
  computed: {
    // 背景颜色改变以及labe样式改变
    textChange() {
      return {
        theme: this.bgConfig.tagBgColor,
        fontStyles: this.fontStyles,
      };
    },

    coverImg() {
      return {
        bgConfig: this.bgConfig,
        elementImg: this.elementImg,
      };
    },

    isHorizontal() {
      const { width, height } = this.size;
      return width > height;
    },
  },
  watch: {
    // 文字样式
    textChange: {
      handler({ fontStyles, theme }) {
        // 最后一行置为空
        this.lastFontStyle = null;
        if (!fontStyles.length) {
          this.fontComputedStyles = [];
          return;
        }
        const labelStyleMenu = getLabelStyleMenu(theme);
        this.fontComputedStyles = fontStyles
          .map((fontStyle, index) => {
            if (!fontStyle.isShowText) return null;
            const style = this.computeFontStyle(fontStyle, labelStyleMenu);
            const text = fontStyle.text.replace(/\n/, "<br />");
            const { isShowText, textMaxLength, textMinLength, isMainTitle } = fontStyle;
            return {
              text,
              style,
              isShowText,
              textMaxLength,
              textMinLength,
              isMainTitle,
            };
          })
          .filter(Boolean);

        // 处理竖版最后一行
        if (!this.isHorizontal) {
          this.lastFontStyle = this.fontComputedStyles.pop();
          this.lastFontStyle.style.width = "100%";
        }
        // 查找主标题，主标题的宽是文字框的宽
        const mainLine = this.fontComputedStyles.find(font => font.isMainTitle);
        mainLine && (this.textBoxWidth = mainLine.style.width);
      },
      deep: true,
      immediate: true,
    },
    // 加载背景图和元素图
    coverImg: {
      handler(newImg) {
        this.isLoadingImg = true;
        this.imgLoading(newImg);
      },
    },
    textConfig: {
      handler(textConfig) {
        this.setTextBoxStyle(textConfig);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 优化文字样式计算方法
    computeFontStyle(fontStyle, labelStyleMenu) {
      const {
        fontColor,
        marginTop,
        fontSize,
        lineHeight,
        fontFamily,
        isShowText,
        textMaxLength,
        textMinLength,
        isMainTitle,
        text,
        labelStyle,
        isLabelStyle,
      } = fontStyle;
      // 折行的index
      const wrapIndex = text.search(/\n/);
      const baseStyle = {
        display: "inline-block",
        color: fontColor,
        marginTop: `${marginTop}px`,
        fontSize: `${fontSize}px`,
        fontFamily,
        lineHeight: `${lineHeight || fontSize}px`,
        minHeight: `${isMainTitle ? lineHeight * 2 + 4 : lineHeight}px`,
        minWidth: `${(parseInt(textMinLength) + 1) * fontSize}px`,
        width: `${fontSize * (wrapIndex > -1 ? wrapIndex : text.length)}px`,
      };
      if (isLabelStyle && labelStyle) {
        const labelStyleObj = labelStyleMenu[labelStyle.substr(-1)].style;
        const padding = (lineHeight - fontSize) / 2;
        const adjustedPadding = labelStyleObj.border ? padding - 1 : padding;
        return {
          ...baseStyle,
          ...labelStyleObj,
          padding: `${adjustedPadding - 1}px 0.5em ${adjustedPadding + 1}px`,
          textShadow: "none",
          width: `calc(${fontSize * text.length}px + 1em)`,
          lineHeight: `${fontSize}px`,
        };
      }

      return baseStyle;
    },

    // 优化图片加载方法
    async imgLoading(newImg) {
      try {
        const [bgLoaded, elementLoaded] = await Promise.all([
          this.getImg(newImg.bgConfig.src),
          this.getImg(newImg.elementImg),
        ]);

        if (bgLoaded && elementLoaded) {
          this.isLoadingImg = false;
          this.$emit("loaded");
        }
      } catch (error) {
        console.error("Image loading failed:", error);
        this.isLoadingImg = false;
      }
    },

    getImg(imgUrl) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = error => reject(error);
        img.src = `//bar.xkw.com${imgUrl}`;
      });
    },

    // 设置背景的大小
    setBgStyle() {
      return {
        width: `${this.size.width}px`,
        height: `${this.size.height}px`,
      };
    },
    // 设置元素的位置样式
    setElementStyle(type) {
      let styleObj = {
        width: `${this.elConfig.elementWidth}px`,
        height: `${this.elConfig.elementWidth / 2}px`,
      };
      styleObj[`margin${type}`] = `${-this.elConfig.offsetX}px`;
      return styleObj;
    },
    // 设置文字的位置
    setTextBoxStyle(textConfig) {
      let textPosition = {};
      const { textPositionY, textPositionX, textAlignType } = textConfig;
      if (textPositionY < 0) {
        textPosition.top = "50%";
        textPosition.transform = "translateY(-50%)";
      } else {
        textPosition.top = textPositionY + "px";
      }
      if (textPositionX < 0) {
        textPosition.left = "50%";
        textPosition.transform = "translateX(-50%)";
      } else {
        // textPosition.left = 0;
        textPosition.left = textPositionX + "px";
      }
      let textHeight = 0;
      for (let i = 0; i < this.fontStyles.length; i++) {
        const fontStyle = this.fontStyles[i];
        if (fontStyle.isMainTitle || /\n/g.test(fontStyle.text)) {
          textHeight += parseInt(fontStyle.lineHeight);
        }
        if (i !== this.fontStyles.length - 1 || this.isHorizontal) {
          textHeight += parseInt(fontStyle.lineHeight) + parseInt(fontStyle.marginTop);
        }
      }
      this.textStyle = {
        ...textPosition,
        height: textHeight + "px",
        textAlign: textAlignType + "" === "0" ? "center" : "left",
        textShadow: `rgba(${hexToRGB(this.bgConfig.textShadowColor)},.6) 0px 2px 4px`,
      };
    },
    handleMaskClick() {
      this.$emit("maskClick");
    },
  },
};
</script>

<style lang="scss" scoped>
.cover {
  position: relative;
  background: no-repeat center center;
  background-size: cover;
  height: 100%;
  z-index: 10;
  background: linear-gradient();
  overflow: hidden;
  .bg {
    height: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .right-element {
    position: absolute;
    bottom: 0;
    right: 0;
    height: 100%;
    overflow: hidden;
    z-index: 10;
    img {
      position: absolute;
      height: auto;
      width: auto;
      bottom: 0;
      right: 0;
    }
    .element-mask {
      position: absolute;
      top: 6px;
      right: 64px;
      opacity: 0;
      width: 96px;
      bottom: 6px;
      z-index: 1;
      cursor: pointer;
      border-radius: 8px;
      border: 2px dashed rgba(255, 137, 94, 0.8);
      background: rgba(255, 137, 94, 0.2);
    }
    &:hover {
      .element-mask {
        opacity: 1;
      }
    }
  }
  .texts {
    position: absolute;
    padding-top: 1px;
    white-space: nowrap;
    text-align: center;
    z-index: 999;
    line-height: 1;
    color: #fff;
    display: flex;
    justify-content: center;
    flex-direction: column;
    // right: 10px;
    .cover-text {
      display: block;
      font-size: 0;
      position: relative;
      &:before {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #ff895e66;
        z-index: 1;
        cursor: pointer;
      }
    }
    .cover-text-input,
    .cover-text-area {
      background: transparent;
      border: none;
      outline: none;
      color: #fff;
      resize: none;
      // max-width: 90%;
      overflow: hidden;
      transition: outline 0.2s ease;
      &:focus {
        outline: 1px solid rgba(255, 255, 255, 0.8);
        background: none;
      }
    }
  }
  input.bottom-label {
    position: absolute;
    bottom: 0;
    color: #fff;
    border: none;
    outline: none;
    left: 0;
    right: 0;
    font-size: 12px;
    line-height: 20px;
    background: rgba(0, 0, 0, 0.3);
    text-align: center;
    z-index: 999;
    &:focus {
      outline: 1px solid rgba(255, 255, 255, 0.8);
      background: none;
    }
  }
  &:hover {
    .cover-text {
      &:before {
        content: "";
      }
      &:focus-within {
        &:before {
          display: none;
        }
      }
    }
  }
}
</style>
